interface WordmarkProps {
  size?: "sm" | "md" | "lg";
  variant?: "light" | "dark";
}

const sizes = {
  sm: { main: "text-lg", dot: "text-sm" },
  md: { main: "text-2xl", dot: "text-lg" },
  lg: { main: "text-4xl", dot: "text-2xl" },
};

export function Wordmark({ size = "md", variant = "light" }: WordmarkProps) {
  const s = sizes[size];
  const garnet = variant === "light" ? "text-garnet" : "text-garnet-light";
  const barrel = variant === "light" ? "text-barrel" : "text-barrel-light";
  const muted = variant === "light" ? "text-terroir" : "text-parchment/70";

  return (
    <span className="inline-flex items-baseline gap-0 tracking-[-0.03em]">
      <span className={`font-mono font-medium ${s.main} ${garnet}`}>wine</span>
      <span className={`font-mono font-medium ${s.main} ${barrel}`}>api</span>
      <span className={`font-mono font-normal ${s.dot} ${muted}`}>.io</span>
    </span>
  );
}
